/**
 * @license
 * Copyright 2023 Ada School
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export enum Language {
  EN = "en",
  ES = "es",
  PT = "pt",
  KO = "ko",
  FR = "fr",
}

export const systemAvailableLanguages: Language[] = [
  Language.EN,
  Language.ES,
  Language.PT,
  Language.KO,
  Language.FR,
];

export const mainLanguage: Language = Language.ES;

const memo = new Map();

export const normalizeLanguage = (language: string): Language => {
  if (memo.has(language)) {
    return memo.get(language);
  }

  if (language.toLowerCase().includes(Language.ES.toLowerCase())) {
    memo.set(language, Language.ES);
    return Language.ES;
  }

  if (language.toLowerCase().includes(Language.PT.toLowerCase())) {
    memo.set(language, Language.PT);
    return Language.PT;
  }

  if (language.toLowerCase().includes(Language.KO.toLowerCase())) {
    memo.set(language, Language.KO);
    return Language.KO;
  }

  if (language.toLowerCase().includes(Language.FR.toLowerCase())) {
    memo.set(language, Language.FR);
    return Language.FR;
  }

  memo.set(language, Language.EN);

  return Language.EN;
};

export const languageFlag = (language: Language | string): string => {
  const normalized = normalizeLanguage(language);

  switch (normalized) {
    case Language.ES:
      return "🇪🇸";
    case Language.PT:
      return "🇵🇹";
    case Language.KO:
      return "🇰🇷";
    case Language.FR:
      return "🇫🇷";
    default:
      return "🇬🇧";
  }
};

export const languageName = (language: Language | string): string => {
  const normalized = normalizeLanguage(language);

  switch (normalized) {
    case Language.ES:
      return "Español";
    case Language.PT:
      return "Português";
    case Language.KO:
      return "한국어";
    case Language.FR:
      return "Français";
    default:
      return "English";
  }
};
